export const DocumentReducer = (state = {}, action) => {
    switch (action?.type) {
        case 'FETCH_DOCUMENT_TYPES':
            return {
                ...state,
                documentTypes: action?.payload,
            };
        case 'DOC_UPLOAD_PROGRESS':
            return {
                ...state,
                docUploadProgress: action?.payload,
            };

        default:
            return state;
    }
};
